import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {InputTextModule} from 'primeng/inputtext';

import { AppComponent } from './app.component';
import {routing} from './app-routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {ClienteService} from './service/cliente/cliente.service';
import {ToastModule} from 'primeng/toast';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {KeyFilterModule} from 'primeng/keyfilter';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuardService } from './service/guards/auth-guard.service';
import { AuthService } from './service/auth/auth.service';
import { CalendarModule } from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import { PromoOctubre } from './pages/promooctubre/promooctubre';
import { soloNumeros } from './directive/solonumeros.directive';
import { soloLetras } from './directive/sololetras.directive';
import { PromoPlenitud } from './pages/promoplenitud/promoplenitud';
import { PromoBabysec } from './pages/promobabysec/promobabysec';
import { PromoAdulto } from './pages/promoadulto/promoadulto';
import { BabySecset } from './pages/babysecset/babysecset';
import { Huggies } from './pages/huggies/huggies';
import { Dermo } from './pages/dermo/dermo';
import { Dermo20 } from './pages/dermo20/dermo20';
import { Redoxito } from './pages/redoxito/redoxito';
import { Secos } from './pages/secos/secos';
import { Tenna } from './pages/tenna/tenna';

import { Mondsub } from './pages/mondsub/mondsub';
import { Home } from './pages/home/home';
import { TagManagerService } from './service/tagmanager/tagmanager.service';
import { Ladysoft } from './pages/ladysoft/ladysoft';
import { Farma } from './pages/farma/farma';
import { Cyber } from './pages/cyber/cyber';
import { Ensure } from './pages/ensure/ensure';
import { Consumo } from './pages/consumo/consumo';
import { Nutricion } from './pages/nutricion/nutricion';
import { Babysec } from './pages/babysec/babysec';
import { Sorteo } from './pages/sorteo/sorteo';
import { BoticaComponent } from './pages/botica/botica.component';
import { InkaclubComponent } from './pages/inkaclub/inkaclub.component';
import { CotidianComponent } from './pages/cotidian/cotidian.component';
import { AspirinaComponent } from './pages/aspirina/aspirina.component';
import { EucerinComponent } from './pages/eucerin/eucerin.component';
import { MultimarcaNutricionComponent } from './pages/multimarca-nutricion/multimarca-nutricion.component';
import { HomeSorteosComponent } from './pages/home-sorteos/home-sorteos.component';
import { CapilatisComponent } from './pages/capilatis/capilatis.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SorteoMilsolesComponent } from './pages/sorteo-milsoles/sorteo-milsoles.component';
import { ModalComponent } from './pages/sorteo-milsoles/modal/modal.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SorteoAgoraComponent } from './pages/sorteo-agora/sorteo-agora.component';
import { SorteoNinetComponent } from './pages/sorteo-ninet/sorteo-ninet.component';
import { Ninet } from './pages/ninet/ninet';
import { SuplementoAdultoComponent } from './pages/suplemento-adulto/suplemento-adulto.component';
import { ProveedorService } from './service/proveedor/proveedor.service';


@NgModule({
  declarations: [
    AppComponent,
    PromoOctubre,
    PromoPlenitud,
    PromoBabysec,
    PromoAdulto,
    Ladysoft,
    Cyber,
    Ensure,
    Redoxito,
    Secos,
    Tenna,
    BabySecset,
    Huggies,
    Babysec,
    Sorteo,
    Dermo,
    Dermo20,
    Farma,
    Consumo,
    Nutricion,
    Mondsub,
    Home,
    Ninet,
    soloNumeros,
    soloLetras,
    BoticaComponent,
    InkaclubComponent,
    CotidianComponent,
    AspirinaComponent,
    EucerinComponent,
    MultimarcaNutricionComponent,
    HomeSorteosComponent,
    CapilatisComponent,
    NotFoundComponent,
    SorteoMilsolesComponent,
    ModalComponent,
    SorteoAgoraComponent,
    SorteoNinetComponent,
    SuplementoAdultoComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    routing,
    HttpClientModule,
    DropdownModule,
    ToastModule,
    InputTextModule,
    CalendarModule,
    BrowserAnimationsModule,
    KeyFilterModule,
    DialogModule,
    OverlayPanelModule,
    ButtonModule,
    ReactiveFormsModule,
    NgbModule,
    DynamicDialogModule,
    FlexLayoutModule
  ],
  entryComponents: [ModalComponent],
  providers: [ClienteService, AuthGuardService, AuthService, TagManagerService, ProveedorService],
  bootstrap: [AppComponent]
})
export class AppModule { }
